<template lang="pug">
.v-vacancies.vacancies(v-if="data" :id="data?.id")
	h2.vacancies__title(v-if="data.title") {{ data.title }}
	.vacancies__filter(v-if="data.field")
		v-field-select.vacancies__field(:field="{...data.field, view: 'outline'}" :model-value="data.field.value" @update:modelValue="fieldChanged" )
	template(v-if="data.items && data.items.length")
		.vacancies__items
			.vacancies__item(v-for="item in data.items")
				.labels(v-if="item.labels && item.labels.length")
					.labels__item(v-for="label in item.labels" :class="[label.type ? 'labels__item--' + label.type : '']") {{ label.text }}
				.vacancies__item-content
					.vacancies__item-title(v-if="item.title") {{ item.title }}
					.vacancies__item-text(v-if="item.text") {{ item.text }}
				a.vacancies__item-link(:href="item.link")
		v-page-nav.search-result__page-nav(:page="data.page" @navigate="navigate")
	.vacancies__message(v-else-if="data.message") {{ data.message }}
</template>

<script>

import sourceMixin from "./mixins/v-mixin-source.vue";
import isMobMixin from "../components/mixins/v-mixin-is-mob.vue";

export default {

	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			data: null,
			page: null
		}
	},

	methods: {
		dataSet(data, options = {}) {
			this.data = data;
			this.page = data.page;
			if (window.location.pathname.indexOf('/local/') < 0 && options.updateUrl) {
				window.history.replaceState(null, null, data.remote);
			}
		},

		requestDataLoad(dataSetOptions) {
			if (this.loading) {
				return;
			}
			this.loading = true;
			this.dataLoad({
				url: this.data.remote,
				delay: false,
				method: 'POST',
				data: {
					id: dataSetOptions.id,
					page: dataSetOptions.page || this.page
				},
			}, dataSetOptions);
		},

		navigate(page) {
			this.page.offset = page.offset;
			this.page.limit = page.limit;
			this.requestDataLoad({updateUrl: true});
		},

		fieldChanged(value) {
			this.requestDataLoad({updateUrl: true, id: value});
		}
	}
}

</script>
